import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq',
  styleUrls: ['./faq.component.scss'],
  templateUrl: './faq.component.html'
})

export class FaqComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
